import { render } from "./SponsorshipPage.vue?vue&type=template&id=d99ce0f2&scoped=true"
import script from "./SponsorshipPage.vue?vue&type=script&lang=js"
export * from "./SponsorshipPage.vue?vue&type=script&lang=js"

import "./SponsorshipPage.vue?vue&type=style&index=0&id=d99ce0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99ce0f2"]])

export default __exports__